exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bold[data-v-aff56ea8] {\n  font-weight: bold;\n}\n.clickable[data-v-aff56ea8]:hover {\n  cursor: pointer;\n}\n.white-out[data-v-aff56ea8] {\n  background-color: white;\n  opacity: 0.6;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 4;\n}", ""]);

// exports
